(($)=>{
    "use strict";

    const $el = $('.language-select');

    if(!$el.length) return;

    const $list = $('.language-list', $el);

    $('.language-select-toggle, .language-list a').on('focus', function(){
        $list.addClass('on');
    }).on('blur',function(){
        $list.removeClass('on');
    }).on('keydown',function(e){
        // trigger click on enter and space keys on focused sub link.
        if(e.which && (e.which===13 || e.which === 32) ){

            if(e.target.classList.contains('language-select-toggle')){
                $list.toggleClass('on');
                e.preventDefault();
            }else{
                this.click();
            }

        }
    });


})(jQuery);